import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "openIcon", "closeIcon"];

  toggle() {
    this.panelTarget.classList.toggle("hidden");
    this.panelTarget.classList.toggle("flex");
    if (this.hasOpenIconTarget) this.openIconTarget.classList.toggle("hidden");
    if (this.hasCloseIconTarget) this.closeIconTarget.classList.toggle("hidden");
    this.syncScrollLock();
  }

  disconnect() {
    this.syncScrollLock();
  }

  // Hold the page still while a takeover is open.
  //
  // Every panel this controller drives is a fixed full-screen (or
  // below-the-header) overlay on mobile, and the page behind one still
  // scrolled: a swipe that missed the panel's own scroller moved the
  // document instead. On the header's nav that also carried the close X
  // out of the viewport -- it lives in the header bar, which is
  // absolute/relative, not fixed -- leaving the menu open with no way to
  // shut it. Freezing the document keeps the X exactly where it was when
  // the menu opened.
  //
  // .modal-open (overflow: hidden) is this codebase's existing lock, from
  // the legacy modal stylesheet and already used by step1's detail overlay
  // -- not a second mechanism invented here.
  //
  // Derived from what is actually on screen rather than from a per-
  // instance flag, because a page can carry several of these (step1 has
  // the header nav, the search takeover, the filter takeover and the sort
  // sheet) and a blind add/remove pair would let one closing panel unlock
  // the page while another is still open. The position check is what
  // excludes the panels that turn into ordinary in-flow content at lg: --
  // those are "not hidden" at desktop widths but must never lock anything.
  //
  // The ownership flag matters because .modal-open is shared:
  // step1_results_controller sets the same class for its detail overlay.
  // Releasing only a lock this controller took means a mobile-menu panel
  // disconnecting (step1 re-renders its results list, sort sheet and all)
  // can never unlock the page out from under that overlay.
  syncScrollLock() {
    const anyOpen = Array.from(
      document.querySelectorAll('[data-mobile-menu-target="panel"]')
    ).some(
      (panel) =>
        !panel.classList.contains("hidden") &&
        getComputedStyle(panel).position === "fixed"
    );

    if (anyOpen) {
      document.body.classList.add("modal-open");
      document.body.dataset.mobileMenuLock = "1";
    } else if (document.body.dataset.mobileMenuLock) {
      delete document.body.dataset.mobileMenuLock;
      document.body.classList.remove("modal-open");
    }
  }
}
